import type { Static } from 'runtypes';
import { Null, Number, Record, String } from 'runtypes';
import { BaseEventRuntype } from './base';

const CoreEventRuntype = BaseEventRuntype.And(
  Record({
    eventId: String,
    receivedAt: String,
    timestamp: String,
    userId: Number,
    userUuid: String.Or(Null).optional(),
    version: Number,
  })
);

type CoreEvent = Static<typeof CoreEventRuntype>;

export { CoreEventRuntype };
export type { CoreEvent };
